<section class="article">
  <article>
    <h2>Ein Fehler ist aufgetreten!</h2>
    <router-outlet></router-outlet>
  </article>
</section>
